/**
 * Auth utility for API requests
 * Handles JWT token injection and 401 redirects
 */

export function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('vc_jwt_token')
  
  if (!token) {
    return {
      'Content-Type': 'application/json',
    }
  }

  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }
}

export function clearAuthToken(): void {
  localStorage.removeItem('vc_jwt_token')
  localStorage.removeItem('vc_username')
  localStorage.removeItem('vc_display_name')
  localStorage.removeItem('vc_caregiver_id')
}

export function handleAuthError(error: any): void {
  if (error instanceof Response && error.status === 401) {
    clearAuthToken()
    window.location.href = '/login'
  }
}

export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const headers = {
    ...getAuthHeaders(),
    ...(options.headers as HeadersInit || {}),
  }

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  })

  if (response.status === 401) {
    clearAuthToken()
    window.location.href = '/login'
    throw new Error('Unauthorized')
  }

  return response
}
